var _style, _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBancoamazonas = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF0B0B;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.6,500H69.4C31.1,500,0,468.9,0,430.6V69.4C0,31.1,31.1,0,69.4,0h361.2C468.9,0,500,31.1,500,69.4v361.2 C500,468.9,468.9,500,430.6,500z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v-card_visa"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.5,202.1c0,33.5,0.2,59.1-0.1,84.7c-0.2,19.3-9,24.1-25.5,14.6c-11.9-6.9-23.6-14.1-35.7-20.7 c-7.5-4.2-10.6-10-10.5-18.6c0.3-32.9,0.2-65.7,0.1-98.6c-0.1-19.3-7.3-23.2-24.1-13.3c-15.5,9.1-30.8,18.4-46.4,27.3 c-10.4,5.9-15.3,3.6-15.5-8.3c-0.3-19.8,0.6-39.7,1-59.5c0.1-3.2,0.9-6.4,3.7-8c24.8-14.1,47.2-33.2,75.8-39.6 c38.8-8.7,69.4,14,75.3,55.3C363,148,359.4,179.1,360.5,202.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.3,344.1c0.1,16.8,0.3,33.6-4.5,50.1c-10.4,35.7-40.5,52.8-76.5,43.1c-7.8-2.1-15.3-4.9-22.2-9.1 c-44.5-26.8-89.2-53.5-133.6-80.5c-17.3-10.5-16.8-19.7,1-29.6c12-6.7,24.2-13.2,36-20.1c7.1-4.2,13.3-3.6,20.3,0.7 c28.7,17.6,57.5,35,86.4,52.1c14.6,8.6,20.9,4.9,21.2-12.3c0.3-18,0-35.9,0.4-53.9c0.3-14.5,5.5-17.4,17.7-10.1 c14.5,8.6,28.6,17.8,43.2,26.1c8,4.5,11.3,10.5,10.7,19.6C440.8,328,441.3,336.1,441.3,344.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.6,218.7c7.4,26.8-6.4,40.5-29,51.5c-23.6,11.5-45.6,26.3-68.2,39.9c-13.7,8.3-13.7,16.1,0.3,24.2 c16.2,9.4,32.8,18.1,49,27.4c11.5,6.5,11.5,11.9,0.1,18.7c-15.4,9.2-31,18.1-46.5,27.2c-5.3,3.1-10.3,4.4-16.1,1 c-16.9-9.7-34.3-18.5-50.7-28.9c-17.5-11.1-31.5-25.7-35-47.4c-4.8-29.6,9.9-51.2,32.9-65.6c46.5-29.3,94.3-56.6,141.8-84.3 c12.5-7.3,20.8-2.2,21.4,12.2C255.8,202.6,255.6,210.7,255.6,218.7z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBancoamazonas);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BANCOAMAZONAS.79e30df0db325cda1dedc95d81912521.svg";